import { Pipe, PipeTransform } from '@angular/core';
import {
  PartnerCopyNameForm,
  getPartnerCopyName,
} from '../../core/partners/partner-registry';

@Pipe({
  name: 'partnerCopyName',
  standalone: true,
})
export class PartnerCopyNamePipe implements PipeTransform {
  transform(
    partnerId?: number | null,
    form: PartnerCopyNameForm = 'full'
  ): string {
    return getPartnerCopyName(partnerId, form);
  }
}
